

export { CBottomFooterCopyright } from '../../fragments/c-bottom-footer-copyright'
